import React, { useEffect, useState, useRef, useContext, use } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, GetSKUDetailGlb, UpdateShoppingCart } from "../GlobalScript";
import Cookies from 'js-cookie';
import ReactPaginate from 'react-paginate';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer.js';
import { ShoppingCartContext } from './ShoppingCartContext';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
export default function SavedOrders() {

    const navigate = useNavigate();
    const [pageResults, setPageResults] = useState(10);
    const [tempPage, setTempPage] = useState(10);
    const [resultsLength, setResultsLength] = useState(0);
    const [orderItems, setOrderItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + pageResults;
    /*const currentItems = orderItems.slice(itemOffset, endOffset);*/
    const pageCount = Math.ceil(orderItems.length / pageResults);
    const currentItems = orderItems.slice(itemOffset, endOffset);
    const location = useLocation();
    const [OrderStatusList, setOrderStatusList] = useState(false);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    const [pop, setPop] = useState(false);

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));     
        document.title = 'K-Dealer - Saved Orders';
    });
    
    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            LoadOrders('', false);
        }
    }, [keyword])

    useEffect(() => {
        if (loading === true) {    
            LoadOrders('', false);
            setLoading(false);
        }
    }, [loading]);


    const LoadOrders = async (orderby, inc) => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                label: user.dealerID,
                value: user.userKey.toString(),             
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetSavedOrderList", requestOptions);
            if (response.status !== 200) {
                return;
            }
            const orders = await response.json();
            setOrderItems(orders);
            setResultsLength(orders.length);
        } catch (e) {
            console.log(e);
            return;
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const handlePageClick = (event) => {
        const newOffset = (event.selected * pageResults) % orderItems.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            setPageResults(tempPage);
        }
    }

    const deleteOrder = async (key) => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                label: user.dealerID,
                value: key.toString()
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/DeleteSavedOrder", requestOptions);
            if (response.status !== 200) {
                //add error msg
            }
            LoadOrders('', false);
            //add confiramtion msg

        } catch (e) {
            console.log(e);
            return;
        }
    };
    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);
    const continueOrder = async (key) => {
        try {
            CheckSession();
            handlePop();
            const user = GetCoockie();
            const data = {
                label: user.dealerID,
                value: key.toString()
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetSavedOrder", requestOptions);
            if (response.status !== 200) {
                //error message
                return;
            }
            const items = await response.json();
            const skuqty = [];
            items.items.forEach(element => {
                skuqty.push({
                    sku: element.sku,
                    qty: element.qty
                });
            });
            const res = await GetSKUDetailGlb(skuqty, items.orderType, items.orderName, items.shipTo.dealerID);
            if (res && res.cart) {
                UpdateShoppingCart(res.cart, setShoppingCart);
                navigate('/neworder');
            }
            else if(res && res.error){
                //error message
            }

        } catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    };
    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">SAVED ORDERS</h1>
                    </Col>
                    <Col className="checkout-title-under"></Col>
                </Row>

                {/*<Row>*/}
                {/*    <Col sm={12}>*/}
                {/*        <Card>*/}
                {/*            <Card.Body>*/}
                {/*                <Row>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Keyword" className="mb-4">*/}
                {/*                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <Form.Select aria-label="Status" onChange={handleChange} value={status} name="status" className="tall-select">*/}
                {/*                            <option value={''}>All</option>*/}
                {/*                            {*/}
                {/*                                OrderStatusList && OrderStatusList.map((item, index) => (*/}
                {/*                                    <option key={item.value} value={item.value}>{item.label}</option>*/}
                {/*                                ))*/}
                {/*                            }*/}
                {/*                        </Form.Select>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Date From" className="mb-4">*/}
                {/*                            <Form.Control id="dateFrom" type="text" placeholder="Date From" value={dateFrom} className={'form-control'} onChange={handleChange} name="dateFrom" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Date To" className="mb-4">*/}
                {/*                            <Form.Control id="dateTo" type="text" placeholder="Date To" value={dateTo} className={'form-control'} onChange={handleChange} name="dateTo" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}

                {/*                    <Col sm={{ offset: 8 }} className="text-right" style={{ alignSelf: 'center' }}>*/}
                {/*                        <p className="clickable underline green-text" onClick={ResetSearch }>Reset Search</p>*/}
                {/*                    </Col>*/}

                {/*                    <Col className="text-center mb-3">*/}
                {/*                        <Button variant="secondary"  onClick={handleSearchClick}>*/}
                {/*                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">*/}
                {/*                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />*/}
                {/*                            </svg>*/}
                {/*                            SEARCH*/}
                {/*                        </Button>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*            </Card.Body>*/}
                {/*        </Card>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                <Row className="mt-4 mb-4">
                    <Col sm={12}>
                        <Card className="">
                            <Card.Body>
                                {/*<Row className="table-legend text-center">*/}
                                {/*    <Col sm={12}>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>*/}
                                {/*        </div>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>*/}
                                {/*        </div>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>*/}
                                {/*        </div>*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}

                                <Row className="pagination-row">
                                    <Col sm={12}>
                                        <p>
                                            <span className="bold">{resultsLength > 0 && resultsLength}</span> results | View
                                            <div className="paginate-results">
                                                <input name="tempPage" type="text" value={tempPage} onChange={handleChange} className="form-control" />
                                                <button className="btn btn-black btn-pagenav" onClick={changePageResults}>Go</button>
                                            </div>
                                        </p>

                                        <ReactPaginate
                                            breakLabel="..."
                                            nextLabel="next >"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={5}
                                            pageCount={pageCount}
                                            previousLabel="< previous"
                                            renderOnZeroPageCount={null}
                                            containerClassName="table-navigation"
                                            previousLinkClassName="table-nav-link"
                                            nextLinkClassName="table-nav-link"
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={12} className="order-table">
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>NAME</th>
                                                    <th>TYPE</th>
                                                    <th>DATE CREATED</th>
                                                    <th>LAST UPDATED</th>
                                                    <th>CONTINUE</th>
                                                    <th>DELETE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                                {currentItems && currentItems.map((item, index) => (
                                                    <tr className="" key={item.key}>
                                                        <td>{index + 1}</td>
                                                        <td className="bold">{item.name}</td>
                                                        <td>{item.type}</td>
                                                        <td>{item.dateCreated}</td>
                                                        <td>{item.dateModified}</td>
                                                        <td>
                                                            <Button variant="primary" onClick={() => continueOrder(item.key, 1)}>
                                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                </svg>
                                                                CONTINUE
                                                            </Button>
                                                        </td>
                                                        <td>
                                                            <Button variant="danger" onClick={() => deleteOrder(item.key, 2)}>
                                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                </svg>
                                                                DELETE
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                             
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />
            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>
        </>
    );
}